module.exports = __webpack_public_path__ + "static/media/iconVideoStepHorizontalDone.a7a5b9cb.svg";